<template>
  <div v-if="footerBanner" class="footer-banner bg-card rounded-lg shadow-md overflow-hidden border border-border mb-8">
    <div class="grid md:grid-cols-2 gap-4">
      <div class="p-6 flex flex-col justify-center">
        <h3 class="text-2xl font-bold mb-2">{{ footerBanner.title }}</h3>
        <p class="text-muted-foreground mb-4">{{ footerBanner.content }}</p>
        <NuxtLink 
          :to="footerBanner.link" 
          class="inline-flex items-center px-6 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          {{ footerBanner.button }}
        </NuxtLink>
      </div>
      <div class="relative h-[200px] md:h-auto">
        <img 
          :src="footerBanner.image" 
          :alt="footerBanner.title"
          class="w-full h-full object-cover"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { usePromotionalStore } from '~/stores/promotional'

const promotionalStore = usePromotionalStore()

// Get the first footer banner from the store
const footerBanner = computed(() => {
  const banners = promotionalStore.footerBanners
  return banners && banners.length > 0 ? banners[0] : null
})
</script> 